import React from 'react';
import {useDispatch} from 'react-redux';
import styles from './MobileSideBarMenu.module.scss';
import { logout as signout } from '../../features/login/loginActionCreators'

interface LogoutButtonProps {
    onClick(): void;
}

export const MobileSideBarMenuLogoutButton: React.FunctionComponent<LogoutButtonProps> = ({onClick}) => {
    const dispatch = useDispatch();

    const logout = async () => {
        await dispatch(signout(onClick))
    }

    return (
        <button 
            type="button"
            className={`${styles.mobileSideBarMenuItemContainer} ${styles.logoutButton}`} 
            onClick={logout}
        >
            <span className={`${styles.mobileSideBarMenuItemLink} ${styles.normalLinks}`}>
                <i className={`far fa-sign-out`} aria-hidden="true"></i>Logout
            </span>
        </button>
    );
}